const initDropdownTabs = (tabList, index) => {
    if (!tabList) return;
  
    const listId = tabList.id || `tab-filter-${index}`;
    tabList.id = listId;
  
    const activeTab = tabList.querySelector(".cmp-tabs__tab--active") || tabList.querySelector("li[role='tab']");
    const activeText = activeTab ? activeTab.textContent.trim() : "";
  
    const button = document.createElement("button");
    button.className = "dropdown-selector expanded";
    button.setAttribute("aria-controls", listId);
    button.setAttribute("aria-expanded", "false");
  
    const textDiv = document.createElement("div");
    textDiv.className = "text";
    textDiv.textContent = activeText;
  
    const iconDiv = document.createElement("div");
    iconDiv.className = "icon";
  
    button.appendChild(textDiv);
    button.appendChild(iconDiv);
  
    tabList.parentNode.insertBefore(button, tabList);
    tabList.style.display = "none";
  
    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      tabList.style.display = expanded ? "none" : "flex";
    });
  
    const tabs = tabList.querySelectorAll("li[role='tab']");
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => {
          t.classList.remove("cmp-tabs__tab--active");
          t.setAttribute("aria-selected", "false");
          t.setAttribute("tabindex", "-1");
        });
  
        tab.classList.add("cmp-tabs__tab--active");
        tab.setAttribute("aria-selected", "true");
        tab.setAttribute("tabindex", "0");
  
        textDiv.textContent = tab.textContent.trim();
        button.setAttribute("aria-expanded", "false");
        tabList.style.display = "none";
      });
    });
  };
  
  const onDocumentReady = () => {
    const tabLists = document.querySelectorAll(".faq ol[role='tablist']");
    tabLists.forEach((tabList, index) => {
      initDropdownTabs(tabList, index);
    });
  };
  
  if (document.readyState !== "loading") { 
    onDocumentReady();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentReady);
  }